import { formatDate } from '@angular/common';
import { NativeDateAdapter } from '@angular/material/core';

export class DatepickerDateAdapter extends NativeDateAdapter {
    override parse(value: string, parseFormat?: any): Date | null {
        // default format for english
        if (this.locale === 'en') {
            return super.parse(value, parseFormat);
        }

        // all other locales: format must be 'DD.MM.YYYY'
        const valueSplit = value.split('.');

        if (valueSplit.length !== 3) {
            // eslint-disable-next-line no-null/no-null
            return null;
        }
        return new Date(Date.parse(`${valueSplit[2]}-${valueSplit[1]}-${valueSplit[0]}`));
    }

    override format(date: Date, displayFormat: any): string {
        // default format for english
        if (displayFormat === 'input' && this.locale !== 'en') {
            // all other locales: format 'DD.MM.YYYY'
            return formatDate(date, 'dd.MM.yyyy', this.locale);
        } else {
            return super.format(date, displayFormat);
        }
    }
}
